import React, { Component } from 'react'
import './styles/TeamEdit.css'
import firebase from '../../firebase'

import Notifications, { notify } from 'react-notify-toast';

import PlaceholderImage from '../../assets/placeholder-image.png'

export default class TeamEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      members: [],
      description: "",
      names: [],
      locations: [],
      pictures: [],
      newMemberPic: PlaceholderImage,
      newMemberName: '',
      newMemberLocation: '',
      description: '',
      disabledForm: false,

      firstLoad: true,
    }

    this.show = notify.createShowQueue();
  }

  componentDidMount() {
    const teamRef = firebase.database().ref('team');

    this.show('Data is loading. Please wait.', "warning", 2000);

    teamRef.on('value', (snapshot) => {
      let teamData = snapshot.val();

      let teamMembers = teamData['members'];

      var result = [];
      var memberNames = [];
      var locationNames = [];
      var memberPictures = [];

      for (var i in teamMembers) {
        teamMembers[i]['key'] = i;
        result.push(teamMembers[i]);

        memberNames[i] = teamMembers[i].name;
        locationNames[i] = teamMembers[i].location;
        memberPictures[i] = teamMembers[i].picture;
      }

      if (this.state.firstLoad) {
        this.show('Data loaded.', "success", 2000);
      }

      this.setState({
        members: result,
        description: teamData['description'],
        names: memberNames,
        locations: locationNames,
        pictures: memberPictures,
        firstLoad: false,
      });

    });
  }

  componentWillUnmount() {
    const teamRef = firebase.database().ref('team');

    teamRef.off();
  }

  updateMember = (key) => {
    const teamMemberRef = firebase.database().ref('team/members/'+key);

    this.show('Data is updating...', "warning", 2000);

    teamMemberRef.set({
      location: this.state.locations[key],
      name: this.state.names[key],
      picture: this.state.pictures[key]
    }, (error) => {

      this.setState({
        disabledForm: false
      });

      if (error) {
        this.show('Data failed to update.', "error", 5000);
      } else {
        this.show('Data Saved. Awesome!', "success", 5000);
      }
    })
  }

  addMember = () => {
    const teamMemberRef = firebase.database().ref('team/members/');

    let memberData = {
      name: this.state.newMemberName,
      location: this.state.newMemberLocation,
      picture: this.state.newMemberPic
    }

    let memberKey = teamMemberRef.push().key;

    this.show('Data being added...', "warning", 2000);

    teamMemberRef.child(memberKey).set(memberData, (error) => {
      this.setState({
        disabledForm: false
      });

      if (error) {
        this.show('Data failed to add.', "error", 5000);
      } else {
        this.show('Data Added. Awesome!', "success", 5000);
      }
    })
  }

  deleteMember = (key) => {
    const teamMemberRef = firebase.database().ref('team/members/'+key);

    teamMemberRef.remove().then(() => {
      this.show('Data deleted.', "success", 5000);
    }).catch(() => {
      this.show('Data failed to delete.', "error", 5000);
    });
  }

  updateDescription = () => {
    const teamDescRef = firebase.database().ref('team/description');

    this.show('Description updating...', "warning", 2000);

    teamDescRef.set(this.state.description, (error) => {
      this.setState({
        disabledForm: false
      });

      if (error) {
        this.show('Description failed to update.', "error", 5000);
      } else {
        this.show('Description Updated. Awesome!', "success", 5000);
      }
    });
  }

  handleNameChange = (key, event) => {
    let names = this.state.names;

    names[key] = event.target.value;

    this.setState({
      names: names
    })
  }

  handleLocationChange = (key, event) => {
    let locations = this.state.locations;

    locations[key] = event.target.value;

    this.setState({
      locations: locations
    })
  }

  handleImageChange = (key, event) => {
    let fileReader = new FileReader();

    fileReader.onload = (e) => {
      let pictures = this.state.pictures;
      pictures[key] = e.target.result;

      this.setState({
        pictures: pictures,
      })
    }

    if (event.target.files[0]) {
      fileReader.readAsDataURL(event.target.files[0]);
    }

  }

  handleNewNameChange = (event) => {
    this.setState({
      newMemberName: event.target.value
    })
  }

  handleNewLocationChange = (event) => {
    this.setState({
      newMemberLocation: event.target.value
    })
  }

  handleNewImageChange = (event) => {
    let fileReader = new FileReader();

    fileReader.onload = (e) => {
      this.setState({
        newMemberPic: e.target.result,
      })
    }

    if (event.target.files[0]) {
      fileReader.readAsDataURL(event.target.files[0]);
    }
  }

  handleDescriptionChange = (event) => {
    this.setState({
      description: event.target.value
    })
  }

  render() {

    let teamList = [];

    this.state.members.forEach((element) => {
      teamList.push(
        <div className="box box-lg team-edit-list-item" key = {element.key}>
          <div className="picture-section">
            <img src = {this.state.pictures[element.key]} />
            <input type = "file" onChange={this.handleImageChange.bind(this, element.key)} />
          </div>

          <div className="name-location-section">
            <div>
              Name: <input className="txt-input" 
                      value={this.state.names[element.key]}
                      onChange={this.handleNameChange.bind(this, element.key)} />
            </div>
            <div>
              Location: <input className="txt-input"
                      value={this.state.locations[element.key]}
                      onChange={this.handleLocationChange.bind(this, element.key)} />
            </div>
          </div>

          <div className="buttons-section">
            <button className='btn btn-submit' onClick = {this.updateMember.bind(this, element.key)}>Update</button>
            <button className='btn btn-plain' onClick = {this.deleteMember.bind(this, element.key)}>Delete</button>
          </div>
        </div>
      );
    });

    return (
      <div className = "team-edit-wrapper">
        <Notifications />
        <div className = "team-edit-list-container">

          <div className="box box-lg team-edit-list-item">
            <div className="picture-section">
              <img src={this.state.newMemberPic} />
              <input type="file" onChange={this.handleNewImageChange} />
            </div>

            <div className="name-location-section">
              <div>
                Name: <input className="txt-input"
                  value={this.state.newMemberName}
                  onChange={this.handleNewNameChange} />
              </div>
              <div>
                Location: <input className="txt-input"
                  value={this.state.newMemberLocation}
                  onChange={this.handleNewLocationChange} />
              </div>
            </div>

            <div className="publish-btn-container">
              <button className='btn btn-submit btn-span-80' onClick ={this.addMember}>Add Member</button>
            </div>
          </div>

          <div className="box box-lg team-edit-description-item">
            <div className="textarea-container">
              Description:
              <textarea className="txt-input area" rows="4" value={this.state.description}
                onChange={this.handleDescriptionChange} />
            </div>

            <div className="publish-btn-container">
              <button className='btn btn-submit btn-span-80' onClick={this.updateDescription}>
                      Publish Description
              </button>
            </div>
          </div>

          <div className = "label">Members:</div>

          {teamList}
        </div>
      </div>
    )
  }
}
